import { useMemo } from "react";
import {
    createStringDataField,
    createListField,
    createStatusField,
} from "../../util/format";

/**
 * Field definitions for Claim Analysis Knowledge Base table
 */
export const useKnowledgeBaseFields = () => {
    return useMemo(
        () => [
            createStringDataField("documentMetadata.documentName", "Document Name", { 
                sortable: false,
                secondLevel: "documentName"
            }),
            createStringDataField("documentMetadata.description", "Description", {
                sortable: false,
                secondLevel: "description"
            }),
            createListField("contractNames", "Contracts", { 
                sortable: false,
                hideFromFilter: true 
            }),
            createStatusField("processing_status", "Status", {
                sortable: false,
                altValues: {
                    'Not Started': 'Not Started',
                    'Queued': 'Queued',
                    'Pending': 'Pending',
                    'pending': 'Pending',
                    'In Process': 'In Process',
                    'Processed': 'Processed',
                    'processing': 'Processing',
                    'Failed': 'Failed'
                }
            }),
        ],
        []
    );
};

export { default as ClaimAnalysisKnowledgeBasePage } from "./ClaimAnalysisKnowledgeBasePage";
